// Story 10.4 — Top selecciones de interactive_list, con barra de progreso.

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { AnalyticsTopItem } from '@/lib/analytics-types';

interface Props {
  data: AnalyticsTopItem[];
}

export function TopItemsList({ data }: Props): React.ReactElement {
  const max = data.reduce((acc, d) => (d.count > acc ? d.count : acc), 0);
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Top selecciones</CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <p className="text-sm text-muted-foreground">Sin datos en este periodo.</p>
        ) : (
          <ul className="space-y-2">
            {data.map((item) => {
              const ratio = max === 0 ? 0 : item.count / max;
              return (
                <li key={item.id} className="space-y-1">
                  <div className="flex items-center justify-between text-sm">
                    <span className="truncate">{item.label}</span>
                    <span className="text-muted-foreground">{item.count}</span>
                  </div>
                  <div
                    className="h-2 w-full overflow-hidden rounded-full bg-muted"
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={max}
                    aria-valuenow={item.count}
                    aria-label={`${item.label}: ${item.count} selecciones`}
                  >
                    <div
                      className="h-full bg-primary"
                      style={{ width: `${Math.round(ratio * 100)}%` }}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
